export default __webpack_public_path__ + "a942cc64e01d3777d6d3c98860b347ca.ogg";